module.exports = {"410711001":"东干道街道","410711002":"荣校路街道","410711003":"北干道街道","410711004":"花园街道","410711005":"卫北街道","410711006":"新辉路街道","410711007":"和平路街道","410711100":"王村镇","410711101":"牧野镇","410711400":"新乡化学与物理电源产业园区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410711.json
// module id = 1453
// module chunks = 0